module.exports = {
  name: 'LINERP',
  manifest: {
    themeColor: '#1190cb',
    backgroundColor: '#000000',
  },
  locales: {
    list: ['zh-TW', 'zh-CN', 'en-US'],
    defaultLocale: 'zh-TW',
    defaultTimeZone: 'Asia/Taipei',
  },
  seo: {
    keywords: 'dgFactor',
    description: `seo description`,
  },
  sitemap: {
    types: [
      'page',
    ],
  },
  sms: {
    service: 'twilio',
    global: true,
  },
  feature: {
    /**
     * 各頁面的階層設定(頁面index sidebar使用)
     */
    pageTypes: {
      default: { depth: 1 },
      article: { depth: 2 },
      project: { depth: 1 },
    },

    // 商品分類最多階層數
    productCategoryMaxDepth: 3,

    // SMS功能
    smsModule: true,

    /**
     * 客服模組
     */
    contactModule: true,

    /**
     * iso27001
     */
    iso27001: false,
  },
}
